import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft, Loader } from 'lucide-react'
import { toast } from 'react-hot-toast'
import useDoubleStore from '../store/useDoubleStore'
import DoubleWheel from '../components/DoubleWheel'
import DoubleBetsFeed from '../components/DoubleBetsFeed'
import DoubleWinnerSummary from '../components/DoubleWinnerSummary'

const DoubleRound = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { t } = useTranslation()
  const { loadRoundById } = useDoubleStore()

  const [round, setRound] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadRound = async () => {
      setIsLoading(true)

      try {
        const data = await loadRoundById(id)
        setRound(data)
      } catch (error) {
        toast.error(t('double.round.loadError', 'Не удалось загрузить раунд'))
      } finally {
        setIsLoading(false)
      }
    }

    loadRound()
  }, [id, loadRoundById, t])

  if (isLoading) {
    return (
      <div className="px-4 py-6 pb-16 lg:px-6 lg:py-2 lg:pb-8">
        <div className="mx-auto flex min-h-[60vh] max-w-7xl items-center justify-center">
          <Loader className="w-8 h-8 text-accent-primary animate-spin" />
        </div>
      </div>
    )
  }

  if (!round) {
    return (
      <div className="px-4 py-6 pb-16 lg:px-6 lg:py-2 lg:pb-8">
        <div className="mx-auto max-w-7xl text-red-400">{t('double.round.empty', 'Раунд не найден')}</div>
      </div>
    )
  }

  const bets = Array.isArray(round.bets) ? round.bets : Array.isArray(round.users) ? round.users : []

  return (
    <div className="px-4 py-6 pb-16 lg:px-6 lg:py-2 lg:pb-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <div className="relative flex items-center justify-center lg:min-h-[48px]">
          <button
            onClick={() => navigate('/double/history')}
            className="absolute left-0 inline-flex items-center justify-center rounded-xl border border-white/10 bg-surface p-2.5 text-white hover:text-accent-primary"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="text-2xl lg:text-4xl font-bold text-white">{t('double.round.title', 'Раунд Double')}</h1>
        </div>

        <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_360px]">
          <div className="space-y-6">
            <DoubleWheel
              roundId={round.id}
              status="finished"
              prevSector={round.win_sector}
              winSector={round.win_sector}
              winColor={round.win_color}
            />

            <DoubleWinnerSummary
              bets={bets}
              winColor={round.win_color}
              winSector={round.win_sector}
            />
          </div>

          <div className="space-y-4">
            <div className="rounded-2xl border border-white/10 bg-surface/50 p-4 text-sm text-text-secondary">
              <p>{t('double.round.status', 'Статус')}: <span className="text-white">{round.status || 'finished'}</span></p>
              <p className="mt-1">{t('double.round.id', 'ID')}: <span className="text-white">{round.id}</span></p>
            </div>

            <DoubleBetsFeed bets={bets} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DoubleRound
